module.exports = {"520112101":"东风镇","520112102":"水田镇","520112103":"羊昌镇","520112105":"下坝镇","520112106":"新场镇","520112107":"百宜镇","520112203":"新堡布依族乡","520112206":"偏坡布依族乡","520112401":"顺新社区服务中心","520112402":"新天社区服务中心","520112403":"创新社区服务中心","520112404":"振新社区服务中心","520112405":"高新社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520112.json
// module id = 2264
// module chunks = 0